import { collection, getDocs } from 'firebase/firestore/lite'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import Products from '../components/Products'
import Search from '../components/Search'
import { db } from '../firebase.config'


function Home() {
  const [products,setProducts] = useState([])
  /* const data = useLoaderData() */
  const query = useSelector((state) => state.shopsyReducer.query)
  
  //FireStore
  const prolist = collection(db, "products" );
  

  /* useEffect(()=>{
    setProducts(data.data)
  },[data]) */
  const [fetchError,setFetchError] = useState(false)
  useEffect(()=>{
    async function fetchFirestore() {
   try{
    const data = await getDocs(prolist);
    const result = data.docs.map((doc)=>({...doc.data(),id: doc.id}))
        setProducts(result)
    } catch (error){
      console.log('Error fetching FireStore data',error)
      setFetchError(true)
    }
    return 0;
  }
  fetchFirestore()
   // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])
  console.log('error: ',fetchError);

  const showSearch = useSelector((state)=> state.shopsyReducer.toggleOn)
  const [srch,setSrch] = useState(false)
  useEffect(()=>{
    setSrch(showSearch? showSearch.toggleOn : false);
  },[showSearch])
  console.log(srch)

  return (
    <div className=" pb-14">
      <div className='mx-2'>
      {query.length === 0 ? (
        <>
          {/* {srch ? "" : <OfferBanner />} */}
          <Products products = {products} fetch = {fetchError} />
        </>
      ) : (
        <Search products={products} />
      )}
      </div>
    </div>
  );
}

export default Home